import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-lang-switcher',
  templateUrl: './lang-switcher.component.html',
  styleUrls: ['./lang-switcher.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class LangSwitcherComponent {
  @Input() isEn: boolean = true;
  @Output() toggleLanguage: EventEmitter<boolean> = new EventEmitter();

  fireToggleLanguage() {
    this.toggleLanguage.emit(true);
  }

}
